
export class LiveFile {
  protected _isSaved: boolean;
  protected _url: string;
  protected _file: Blob;

  get file(): Blob {
    return this._file;
  }

  get url(): string {
    return this._url;
  }

  get isSaved(): boolean {
    return this._isSaved;
  }

  constructor(data: string)
  constructor(data: Blob)
  constructor(data: Blob | string | {original:string}) {
    if (data instanceof Blob) {
      this.setFile(data);
    } else if (typeof data === 'string') {
      this.setUrl(data);
    }else if (typeof data === 'object') {
      this.setUrl(data.original);
    } else {
      console.error('Undefined type');
      throw new Error('Undefined type');
    }

  }

  protected setUrl(url: string) {
    this._isSaved = true;
    this._url = url;
  }

  protected setFile(file: Blob) {
    this._isSaved = false;
    this._file = file;
    this._url = URL.createObjectURL(file);
  }

  /*static fromFile(file: Blob): LiveFile {
    let res = new LiveFile();

    res._isSaved = false;
    res._file = file;
    res._url = URL.createObjectURL(file);

    return res;
  }

  static fromUrl(url: string): LiveFile {
    let res = new LiveFile();

    res._isSaved = false;
    res._url = url;

    return res;
  }*/
}




// WEBPACK FOOTER //
// ./src/api/file.ts